<template>
  <q-page padding>
    <PageHeader
      title="Ativar controle de Lote"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <infot-upload
      :activeSlide="activeSlide"
      :link="'https://multpex-docs.s3.amazonaws.com/templates/estoque/template_ativar_controle_estoque_r1.xlsx'"
      :infos="infos"
    />

    <upload-planilha-layout
      titulo="Enviar planilha para ativar controle de lote"
      :file="file"
      :is-drag-over="isDragOver"
      :submit-disabled="!file"
      @drag-over="isDragOver = true"
      @drag-leave="isDragOver = false"
      @drop-file="onDrop"
      @file-selected="onFileSelected"
      @instructions="activeSlide = !activeSlide"
      @submit="enviarTemplate"
    />
  </q-page>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import InfotUpload from "../../compras/components/InfotUpload.vue";
import PageHeader from "../../../../components/PageHeader.vue";
import UploadPlanilhaLayout from "../../../../components/UploadPlanilhaLayout.vue";

export default {
  components: { InfotUpload, PageHeader, UploadPlanilhaLayout },
  setup() {
    const $q = useQuasar();
    const store = useStore();
    const file = ref(null);
    const isDragOver = ref(false);
    const activeSlide = ref(false);

    const infos = ref([
      {
        name: "Para esse serviço é necessário somente o código do Item",
        icon: "do_not_disturb",
      },
      { name: "Não crie nenhuma outra coluna", icon: "delete" },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "view_column",
      },
    ]);

    const onFileSelected = (e) => {
      if (e.target.files[0]) file.value = e.target.files[0];
    };

    const onDrop = (e) => {
      isDragOver.value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        file.value = f;
      } else {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
      }
    };

    const enviarTemplate = async () => {
      if (!file.value || !file.value.name.endsWith(".xlsx")) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }

      $q.loading.show({ message: "Enviando planilha..." });

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        await store.dispatch("estoque/upload", {
          planilha: result,
          mapeamento: "ativacao_lote",
          adicional: { vendor_id: store.state.org.unidadeData.id },
        });

        $q.loading.hide();
        $q.notify({
          message: "Enviado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        file.value = null;
      } catch (error) {
        $q.loading.hide();
        console.log(error);
        $q.notify({
          message: "Erro ao enviar",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    return {
      enviarTemplate,
      file,
      isDragOver,
      activeSlide,
      infos,
      onFileSelected,
      onDrop,
    };
  },
};
</script>
